import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://moonshine-solutions.com';
const DEFAULT_TITLE = 'Moonshine Solutions GmbH – Vermögensaufbau & finanzieller Erfolg';
const DEFAULT_DESC = 'Moonshine Solutions GmbH – dein persönlicher Experte für inflationsgeschützten und steueroptimierten Vermögensaufbau. Immobilien, KI-Trading, Vorsorge, Edelmetalle.';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  schema = null,
  noindex = false,
}) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title === DEFAULT_TITLE ? title : `${title} – Moonshine Solutions`;

  return (
    <Helmet>
      <html lang="de" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Moonshine Solutions" />
      <meta property="og:locale" content="de_CH" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FinancialService',
  name: 'Moonshine Solutions GmbH',
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  image: `${SITE_URL}/logo512.png`,
  description: DEFAULT_DESC,
  founder: {
    '@type': 'Person',
    name: 'Pascal Schwab',
    jobTitle: 'Geschäftsführer',
  },
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'CH',
  },
  areaServed: 'CH',
  sameAs: [
    'https://www.facebook.com/profile.php?id=61556725782230',
    'https://www.instagram.com/pascals.solutions/',
    'https://www.linkedin.com/in/pascal-schwab-55293b264/',
  ],
};

export function serviceSchema({ name, description, url }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    url: `${SITE_URL}${url}`,
    provider: {
      '@type': 'FinancialService',
      name: 'Moonshine Solutions GmbH',
      url: SITE_URL,
    },
    areaServed: { '@type': 'Country', name: 'Switzerland' },
  };
}

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

export { SITE_URL };
